import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { delay, share } from 'rxjs/operators';

import { generalSettings } from '../../../main/settings';

@Injectable()
export class LayoutService {

  protected layoutSize$: Subject<any> = new Subject();

  changeLayoutSize(): void {
    this.layoutSize$.next(true);
  }

  onChangeLayoutSize(): Observable<any> {
    return this.layoutSize$.pipe(
      share(),
      delay(1),
    );
  }

  /* ===============================================
     ---------- E D M   F U N C T I O N S ----------
     =============================================== */

  cardSizeCustomLayoutClass(size: string): string {
    let customClass: string;
    const smallCssClass: string = 'col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-2';
    const mediumCssClass: string = 'col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-3';
    const largeCssClass: string = 'col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-4';
    customClass = size == 'small' ? smallCssClass : (size == 'medium' ? mediumCssClass : largeCssClass);
    return customClass;
  }

  thumbCustomLayoutClass(size: string, orientation: string, titleStyle: string): string {
    return size + '-size ' + orientation + '-orientation ' + titleStyle + '-title';
  }

  buttonCustomLayoutCss(): string {
    return generalSettings.buttonLayout + '-btn';
  }

  maxNumberOfThumbsOnScreen(size: string): number {
    const bootstrapScreenSizes: any = {
      'xs': 0, 'sm': 576, 'md': 768, 'lg': 922, 'xl': 1200
    }
    const screenWidth: number = window.screen.width;
    if (screenWidth < bootstrapScreenSizes.sm) return 1;
    else if (screenWidth < bootstrapScreenSizes.md) return size == 'small' ? 2 : 1;
    else if (screenWidth < bootstrapScreenSizes.xl) return size == 'small' ? 4 : (size == 'medium' ? 3 : 2);
    else return size == 'small' ? 6 : (size == 'medium' ? 4 : 3);
  }

}
